const aiSourceTypes = ['compositeWithTrainedAlgorithmicMedia', 'trainedAlgorithmicMedia'] as const;

export type AiSourceType = (typeof aiSourceTypes)[number];

type BaseProductMedium = {
  readonly digitalSourceType?: AiSourceType | null;
  readonly url: string;
};

const productImageMediumType = 'IMAGE' as const;

export type ProductImageMedium = BaseProductMedium & {
  readonly type: typeof productImageMediumType;
  readonly width: number;
  readonly height: number;
};

const productVideoMediumType = 'VIDEO' as const;

export type ProductVideoMedium = BaseProductMedium & {
  readonly type: typeof productVideoMediumType;
};

export type ProductMedium = ProductImageMedium | ProductVideoMedium;

export const isProductImageMedium = (medium: ProductMedium): medium is ProductImageMedium =>
  medium.type === productImageMediumType;

export const isProductVideoMedium = (medium: ProductMedium): medium is ProductVideoMedium =>
  medium.type === productVideoMediumType;

const hasDigitalSourceType = <T>(
  medium?: T | null | undefined
): medium is T & { readonly digitalSourceType: AiSourceType | null | undefined } =>
  !!medium && Object.hasOwn(medium, 'digitalSourceType');

export const isAiGeneratedProductMedia = <T>(
  medium?: T | null | undefined
): medium is T & { readonly digitalSourceType: AiSourceType } =>
  hasDigitalSourceType(medium) &&
  !!medium.digitalSourceType &&
  aiSourceTypes.includes(medium.digitalSourceType);
